module.exports = "/_next/static/images/stream-is-down-bda758f63f29d4e4f060c29da5578558.svg";